/* Snoepmixen: maat kiezen in een venster (Domino's aanpak). Kleinste maat voorgekozen. De gekozen maat toont de eigen prijs, de andere maten tonen het verschil met de gekozen maat (+5,00 of −5,00) en rekenen mee bij elke klik. De knop zegt alleen Toevoegen; de prijs onder de titel is het totaal, met de doorgestreepte adviesprijs van de gekozen maat ernaast. */
(function () {
  'use strict';
  if (window.__cwMixPick) return; window.__cwMixPick = true;
  var dlg, body, last, bg = '';
  function cardBg(b){var m=b&&b.closest('.card--product, .cwh .card, li');var md=m&&(m.querySelector('.card__media')||m.querySelector('.st'));var c=md?getComputedStyle(md).backgroundColor:'';return c&&c!=='rgba(0, 0, 0, 0)'&&c!=='transparent'?c:'';}
  function money(c) { return (c / 100).toFixed(2).replace('.', ','); }
  function diffLabel(price, sel, isOn) {
    var d = price - sel;
    if (isOn || d === 0) return money(price);
    return (d > 0 ? '+' : '−') + money(Math.abs(d));
  }
  function make() {
    dlg = document.createElement('div');
    dlg.className = 'cwmp'; dlg.hidden = true;
    dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true'); dlg.setAttribute('aria-labelledby', 'cwmp-title');
    dlg.innerHTML = '<div class="cwmp-bg" data-cwmp-close></div><div class="cwmp-box"><button type="button" class="cwmp-x" data-cwmp-close aria-label="Sluiten"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="cwmp-content"></div></div>';
    document.body.appendChild(dlg);
    body = dlg.querySelector('.cwmp-content');
    dlg.addEventListener('click', onClick);
  }
  function state() { var r = body.querySelector('[data-cwmp]'); return r; }
  function update() {
    var r = state(); if (!r) return;
    var on = r.querySelector('.cwmp-size.on'); var q = parseInt(r.querySelector('[data-cwmp-qn]').textContent, 10) || 1;
    var p = on ? parseInt(on.getAttribute('data-p'), 10) : parseInt(r.getAttribute('data-base'), 10);
    var c = on ? (parseInt(on.getAttribute('data-c'), 10) || 0) : 0;
    r.querySelectorAll('.cwmp-size').forEach(function (x) {
      if (x.disabled) return;
      var s = x.querySelector('span'); if (!s) return;
      s.textContent = diffLabel(parseInt(x.getAttribute('data-p'), 10), p, x === on);
    });
    var tot = r.querySelector('[data-cwmp-total]'); if (tot) tot.textContent = money(p * q);
    var pr = r.querySelector('[data-cwmp-price]'); if (pr) pr.textContent = money(p * q);
    var cs = r.querySelector('[data-cwmp-compare]');
    if (cs) { if (c > p) { cs.textContent = money(c * q); cs.hidden = false; } else { cs.textContent = ''; cs.hidden = true; } }
  }
  function onClick(e) {
    if (e.target.closest('[data-cwmp-close]')) { close(); return; }
    var r = state(); if (!r) return;
    var sz = e.target.closest('.cwmp-size');
    if (sz && !sz.disabled) { r.querySelectorAll('.cwmp-size').forEach(function (x) { var o = x === sz; x.classList.toggle('on', o); x.setAttribute('aria-checked', o); }); update(); return; }
    var qb = e.target.closest('[data-cwmp-q]');
    if (qb) { var n = r.querySelector('[data-cwmp-qn]'); var v = Math.max(1, Math.min(20, (parseInt(n.textContent, 10) || 1) + parseInt(qb.getAttribute('data-cwmp-q'), 10))); n.textContent = v; update(); return; }
    var add = e.target.closest('[data-cwmp-add]');
    if (add && !add.disabled) {
      var on = r.querySelector('.cwmp-size.on'); if (!on) return;
      var q = parseInt(r.querySelector('[data-cwmp-qn]').textContent, 10) || 1;
      add.disabled = true; var t = add.innerHTML; add.textContent = 'Bezig...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(on.getAttribute('data-v'), 10), quantity: q }] }) })
        .then(function (res) { if (!res.ok) throw res; return res.json(); })
        .then(function () {
          close();
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
        })
        .catch(function () { add.textContent = 'Lukt niet, probeer opnieuw'; setTimeout(function () { add.disabled = false; add.innerHTML = t; }, 2200); });
    }
  }
  function open(url) {
    if (!dlg) make();
    body.innerHTML = '<div class="cwmp-load">Even laden...</div>';
    dlg.hidden = false; document.documentElement.classList.add('cwmp-open');
    requestAnimationFrame(function () { dlg.classList.add('is-on'); });
    fetch(url.split('?')[0] + '?section_id=cw-mix-pick').then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
      var t = document.createElement('div'); t.innerHTML = html;
      var inner = t.querySelector('[data-cwmp]'); if (!inner) throw new Error('leeg');
      body.innerHTML = ''; body.appendChild(inner); update();
      var im = inner.querySelector('.cwmp-img'); if (im && bg) im.style.background = bg;
      var x = dlg.querySelector('.cwmp-x'); if (x) x.focus();
    }).catch(function () { location.href = url; });
  }
  function close() {
    if (!dlg || dlg.hidden) return;
    dlg.classList.remove('is-on'); document.documentElement.classList.remove('cwmp-open');
    setTimeout(function () { dlg.hidden = true; body.innerHTML = ''; if (last) last.focus(); }, 200);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cw-mixpick]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); last = b; bg = cardBg(b); open(b.getAttribute('data-cw-mixpick'));
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
